import React, { useEffect, useRef, useState } from "react";
import MainMenu from "./MainMenu";
import Bestilltid from "./Betilltid";
import logo from '../logo.png';
import './scss/_header.css';
export default function Header() {


    const spacerRef = useRef<HTMLDivElement | null>(null);
    const headerRef = useRef<HTMLElement | null>(null);
    const [isscrolled, setIsscrolled] = useState(false);
    const threshold = 400; // поріг скролу, після якого фіксуємо хедер

    useEffect(() => {
        const header = document.getElementById("header");
        headerRef.current = header as HTMLElement | null;
        if (!header) return;


        let ticking = false;
        let lastscrolled = false;

        // Виставляємо висоту спейсера, щоб уникати стрибків
        let setSpacerHeight = () => {
            if (!spacerRef.current || !headerRef.current) return;
            if (window.scrollY > threshold) {
                spacerRef.current.style.height =
                    `${headerRef.current.offsetHeight}px`;
            } else {
                spacerRef.current.style.height = "0px";
            }
        };

        const applyscrolled = (shouldStick: boolean) => {
            if (!headerRef.current) return;

            if (shouldStick) {
                if (!headerRef.current.classList.contains("scrolled")) {
                    // 1) Додаємо scrolled (fixed + захований зверху)
                    headerRef.current.classList.add("scrolled");

                    // 2) Ставимо висоту спейсера під поточну висоту хедера
                    setSpacerHeight();

                    // 3) На наступному кадрі додаємо show — починається плавний в’їзд
                    requestAnimationFrame(() => {
                        headerRef.current?.classList.add("show");
                    });
                }
            } else {
                // При поверненні вище порогу — плавно ховаємо і потім знімаємо fixed
                if (headerRef.current.classList.contains("scrolled")) {
                    headerRef.current.classList.remove("show");

                    // Після завершення анімації знімаємо scrolled і прибираємо спейсер
                    const onTransitionEnd = (e: TransitionEvent) => {
                        if (e.propertyName === "transform") {
                            headerRef.current?.classList.remove("scrolled");
                            setSpacerHeight(); // встановить 0
                            headerRef.current?.removeEventListener("transitionend", onTransitionEnd);
                        }
                    };
                    headerRef.current.addEventListener("transitionend", onTransitionEnd);
                }
            }
        };

        const update = () => {
            const shouldStick = window.scrollY > threshold;
            if (shouldStick !== lastscrolled) {
                lastscrolled = shouldStick;
                setIsscrolled(shouldStick);
                applyscrolled(shouldStick);
            } else if (shouldStick) {
                // якщо вже scrolled, тримаємо коректну висоту спейсера при ресайзі/змінах
                setSpacerHeight();
            }
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(update);
                ticking = true;
            }
        };

        update();

        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", setSpacerHeight);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", setSpacerHeight);
        };
    }, [isscrolled]);

    return (
        <>
            <div className="header-spacer" ref={spacerRef} aria-hidden="true" />
            <header id="header" >
                <div id="header-container" className="App-header ">
                    <div className="flex">
                        <a href="#hero" className="main-link">
                            <img src={logo} alt="Hjem" className="App-logo"/>
                        </a>

                    </div>
                    <MainMenu />
                    <div className="header-btn">
                    <Bestilltid/>
                    </div>
                </div>
            </header>
        </>
    );
}